import moment = require("moment");
import {GranularityType} from "../../components/toolsbar/Toolbar";
import {OperativityData} from "./models";

export const operativityTime = Object.freeze({
    maxExtent: {
        start: moment("2020-01-01"),
        end: moment().add(1, "day").startOf("day"),
    },
    startingSelectedExtent: {
        start: moment().add(-14, "day").startOf("day").toDate(),
        end: moment().add(1, "day").startOf("day").toDate(),
    },
    startingTimeExtent: {
        start: moment().add(-14, "day").startOf("day").toDate(),
        end: moment().add(1, "day").startOf("day").toDate(),
    },
});

export function unitFromGranularity(granularity: GranularityType): string {
    switch (granularity) {
        case GranularityType.HOUR: {
            return "hour";
        }
        case GranularityType.DAY: {
            return "day";
        }
        case GranularityType.WEEK: {
            return "week";
        }
        case GranularityType.MONTH: {
            return "month";
        }
        case GranularityType.QUARTER: {
            return "quarter";
        }
        case GranularityType.YEAR: {
            return "year";
        }
        default: {
            return "";
        }
    }
}

export function fillOperativities(operativities: OperativityData[], granularity: GranularityType) {
    return operativities.reduce<OperativityData[]>((result, x, i) => {
        const prev = result[result.length - 1];
        if (prev && moment(prev.date).diff(x.date, unitFromGranularity(granularity) as any) > 1) {
            const gap = emptyOperativities(prev.date, x.date, granularity);
            return [...result, ...gap.slice(1, -1), x];
        }
        return [...result, x];
    }, []);
}

export function emptyOperativities(from: Date, to: Date, granularity: GranularityType) {
    return dates(from, to, unitFromGranularity(granularity))
        .map<OperativityData>((date) => ({
            date: date.toJSON() as any,
            value: 0,
        }));
}

export function dates(from: Date, to: Date, unit: any): Date[] {
    return Array
        .from<Date>({length: moment(to).diff(from, unit) + 1})
        .map((_, i) => moment(from).add(i, unit).toDate());
}

export function dateToLocalISO(date: Date): string {
    return moment(date).toISOString(true);
}

export const dateToISO = (date: Date, keepOffset?: boolean) => {
    return moment(date).toISOString(keepOffset)
};